import React, { useState } from "react";
import { get, isEmpty, sum } from "lodash";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button, Image, Form } from "react-bootstrap";
import PayrollFundingHeader from "./PayrollFundingHeader";
import Cancel from "../../../../styles/cancel.png";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import DisplayFileLevel from "./DisplayByFile/DisplayFileLevel";
import DisplayFundingPlanLevel from "./DisplayByPlan/DisplayFundingPlanLevel";
import DisplayFundingClassificationLevel from "./DisplayByClassification/DisplayFundingClassificationLevel";
import { Formik } from "formik";
import { ROUTES, getPathWithParam } from "../../../../utils";
import { useRouterParams, useRequest } from "../../../../abstracts";
import { Link } from "react-router-dom";
import {
  saveFundingDetailsByFile,
  getClassificationDetailsByFileId,
} from "../../../../services";
import { LoaderWrapper } from "../../../../components";

const initialValues = {};

const PayrollFunding = ({ data }) => {
  const fundingType = get(data, "fundingType");
  const [classificationType, setclassificationType] = useState("File");
  const { payrollId } = useRouterParams();
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [loadForPayrollFunding, setIsLoad] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isViewByDisabled, setViewByDisabled] = useState(false);

  const { response: classifications } = useRequest({
    method: getClassificationDetailsByFileId,
    payload: payrollId,
    defaultResponse: [],
  });
  const onFormSubmit = () => {
    if (classificationType === "File") {
      setIsLoad(true);
      saveFundingDetailsByFile(payrollId)
        .then((response) => {
          if (response) {
            setIsLoad(false);
            setIsModalOpen(true);
          } else {
            setIsLoad(false);
            setShowErrors(true);
          }
        })
        .catch((error) => {
          setIsLoad(false);
          setShowErrors(true);
        });
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const mockOptions = [
    // { label: "Plan", value: "Plan" },
    { label: "File", value: "File" },
  ];
  const dropDownOptns = mockOptions;
  //.concat(
  //  classifications.map((item) => {
  //    return {
  //      label: item.classificationTypeName,
  //      value: item.classificationTypeName,
  //    };
  //  })
  //);

  return (
    <>
      <LoaderWrapper isLoading={loadForPayrollFunding}>
        <Formik
          initialValues={initialValues}
          onSubmit={onFormSubmit}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
        >
          {({ handleSubmit }) => {
            return (
              <Form
                autoComplete="off"
                onSubmit={handleSubmit}
                className="h-100 d-flex"
              >
                <div
                  className="payroll-funding w-100"
                  style={{ minHeight: "68vh" }}
                >
                  <PayrollFundingHeader
                    title="Payroll Funding"
                    subtitle={get(data, "fileName")} //"Gregarious Simulation Systems"
                    classificationType={classificationType}
                    setclassificationType={setclassificationType}
                    optionList={dropDownOptns}
                    menu={"payroll"}
                    subMenu={"uploadFile"}
                    fundingType={fundingType}
                    isViewByDisabled={isViewByDisabled}
                  />

                  {classificationType === "File" ? (
                    <DisplayFileLevel payrollId={payrollId} />
                  ) : classificationType === "Plan" ? (
                    <DisplayFundingPlanLevel
                      payrollId={payrollId}
                      classificationType={classificationType}
                      setViewByDisabled={setViewByDisabled}
                    />
                  ) : (
                    <DisplayFundingClassificationLevel
                      classificationType={classificationType}
                      setViewByDisabled={setViewByDisabled}
                      payrollId={payrollId}
                    />
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
        <Modal show={isModalOpen}>
          <Modal.Body style={{ borderTop: "5px solid #5ACE9F" }}>
            <div className="text-right">
              {/* <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            /> */}
            </div>
            <div className="d-flex">
              <div className="pd-15">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  color="#5ACE9F"
                  size="3x"
                />
              </div>
              <div className="remove-text">
                <h4>Submit Success</h4>
                <p>Your Funding process has been initiated successfully</p>
                <br />
                <Link
                  to={getPathWithParam({
                    path: ROUTES.PAYROLL,
                  })}
                >
                  <Button variant="primary">Ok</Button>
                </Link>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {showErrors && (
          <div
            className={`error-banner justify-content-between d-flex align-items-center ${
              (showErrors && "enable") || "enable"
            }`}
          >
            <div>
              <Image src={Cancel} width="30px" />
            </div>
            <div>
              <div className="error-heading">{errorMsg ? "" : "Oops"}</div>
              <div className="error-reason">
                {errorMsg ? (
                  <span>
                    Please enter the funding amount, to <br />
                    complete the funding process
                  </span>
                ) : (
                  "Something Went wrong"
                )}
              </div>
            </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  setErrorMsg(false);
                  setShowErrors(false);
                }}
              />
            </div>
          </div>
        )}
      </LoaderWrapper>
    </>
  );
};

export default PayrollFunding;
